import React, { useEffect, useRef } from 'react';
import './FloatingKeywords.css';

const FloatingKeywords = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const keywords = [
      'React', 'Django', 'Python', 'JavaScript', 'TypeScript', 'Node.js',
      'MongoDB', 'PostgreSQL', 'AWS', 'Docker', 'Kubernetes', 'Git',
      'API', 'REST', 'GraphQL', 'Microservices', 'CI/CD', 'DevOps',
      'Machine Learning', 'AI', 'TensorFlow', 'PyTorch', 'Data Science',
      'Cloud Computing', 'Serverless', 'Lambda', 'S3', 'EC2', 'VPC',
      'HTML5', 'CSS3', 'SASS', 'Webpack', 'Babel', 'ES6+',
      'Redux', 'Context API', 'Hooks', 'Next.js', 'Express', 'FastAPI',
      'SQL', 'NoSQL', 'Redis', 'Elasticsearch', 'Kafka', 'RabbitMQ',
      'Jest', 'Cypress', 'Selenium', 'Testing', 'TDD', 'BDD',
      'Agile', 'Scrum', 'Kanban', 'JIRA', 'Confluence', 'Slack',
      'Figma', 'Adobe XD', 'Sketch', 'UI/UX', 'Design Systems',
      'Responsive Design', 'PWA', 'SPA', 'SSR', 'SEO', 'Performance',
      'Security', 'OAuth', 'JWT', 'HTTPS', 'SSL', 'Encryption',
      'Blockchain', 'Web3', 'Smart Contracts', 'NFT', 'DeFi',
      'Mobile', 'iOS', 'Android', 'React Native', 'Flutter', 'Swift',
      'Kotlin', 'Java', 'C++', 'Go', 'Rust', 'Scala',
      'Vue.js', 'Angular', 'Svelte', 'Tailwind CSS', 'Bootstrap',
      'Firebase', 'Supabase', 'Prisma', 'TypeORM', 'Sequelize',
      'Nginx', 'Apache', 'CDN', 'Load Balancing', 'Auto Scaling',
      'GitHub', 'GitLab', 'Bitbucket', 'Jenkins', 'Travis CI',
      'Terraform', 'Ansible', 'Chef', 'Puppet', 'Infrastructure as Code',
      'Big Data', 'Hadoop', 'Spark', 'Hive', 'Pig', 'HBase',
      'Neural Networks', 'Deep Learning', 'Computer Vision', 'NLP',
      'GraphQL', 'gRPC', 'WebSockets', 'Socket.io', 'Real-time',
      'Microservices', 'Service Mesh', 'API Gateway', 'Event Sourcing',
      'CQRS', 'Domain-Driven Design', 'Clean Architecture', 'SOLID',
      'Design Patterns', 'Algorithms', 'Data Structures', 'Optimization'
    ];

    // Check if mobile
    const isMobile = window.innerWidth < 768;

    // Performance settings based on device
    const initialCount = isMobile ? 20 : 50;
    const intervalTime = isMobile ? 2500 : 1500;

    // Create floating keyword elements
    const createKeyword = () => {
      // Safety check if container still exists
      if (!container) return;

      const keyword = keywords[Math.floor(Math.random() * keywords.length)];
      const element = document.createElement('div');
      element.className = 'floating-keyword';
      element.textContent = keyword;

      // Random starting position
      const startX = Math.random() * 100;
      const startY = Math.random() * 100;
      const duration = (isMobile ? 20 : 15) + Math.random() * 20;
      const delay = Math.random() * 5;

      element.style.left = `${startX}%`;
      element.style.top = `${startY}%`;
      element.style.animationDuration = `${duration}s`;
      element.style.animationDelay = `${delay}s`;
      element.style.opacity = (0.15 + Math.random() * 0.2).toString();
      element.style.fontSize = `${(isMobile ? 0.7 : 0.9) + Math.random() * 0.5}rem`;

      container.appendChild(element);

      // Remove element after animation completes
      setTimeout(() => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }, (duration + delay) * 1000);
    };

    // Create initial keywords
    for (let i = 0; i < initialCount; i++) {
      setTimeout(() => createKeyword(), i * (isMobile ? 500 : 300));
    }

    // Continuously create new keywords
    const interval = setInterval(() => {
      createKeyword();
    }, intervalTime);

    // Cleanup function
    return () => {
      clearInterval(interval);
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []); // Empty dependency array is now correct because 'keywords' will be defined inside or static

  return <div ref={containerRef} className="floating-keywords-container" />;
};

export default FloatingKeywords;

